






















































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import { getModule } from 'vuex-module-decorators'
import { db } from '../../firebase/init'
import MainMixin from '../../mixins/MainMixin'
import User from '../../store/modules/user'
import SingleTask from '../../components/tasks/SingleTask.vue'
import { TaskType } from '../../types'
import CDatePicker from '../../components/inputs/CDatePicker.vue'
import CardList from '../../components/layout/CardList.vue'

const tasks = collection<TaskType>('tasks')

@Component({
  components: {
    CardList,
    SingleTask,
    CDatePicker,
  },
})

export default class SetupTasks extends Mixins(MainMixin) {
  tabs = [{ title: 'Add Task', value: 'add' }, { title: 'Schedule Tasks', value: 'schedule' }]

  $refs:any

  task:TaskType = {
    task: '',
    details: '',
    employee: '',
    shift: false,
    location: this.location,
    created: new Date(),
    completed: null,
    completedBy: '',
    comments: [],
    due: '',
  }

  resetAll() {
    this.taskType = ''
    this.resetTask()
  }

  resetTask(employee = false) {
    this.task = {
      task: '',
      details: '',
      employee: employee ? this.task.employee : '',
      shift: this.taskType === 'shift',
      location: this.location,
      created: new Date(),
      completed: null,
      completedBy: '',
      comments: [],
      due: '',
    }
  }

  loading = false

  taskType = ''

  employeeShift = ''

  get employeeSelect() {
    if (this.taskType === 'Employee') {
      return this.$store.getters.allUsers
    } if (this.taskType === 'Manager') {
      return this.$store.getters.allManagers
    } return ['50s', '60s', '80s']
  }

  async addTask() {
    this.loading = true
    const isValid = await this.$refs.obs.validate()
    if (!isValid) return false
    this.task.location = this.location
    this.task.created = new Date()
    this.task.shift = this.taskType === 'Shift'
    console.log('valid is: ', isValid)
    console.log('asdf', this.$store.getters.allUsers)
    console.log('Task is: ', this.task)
    await add(tasks, this.task)
    this.$toast.success('Task Added!')
    this.loading = false
    return this.resetAll()
  }
}
